import type { DocsOwner } from '../settings/preLoginSettings/PreLoginDocsPanel';

/**
 * A subcontract order's Attachments / Notes tabs, served to the shared documents panel
 * (PreLoginDocsPanel) by SuboutDocsController — `entry` is Subcontract Result Entry,
 * `test-order` Subcontract Test Order / Registration. Both read the same rows (the order's
 * dbo.Attachment / dbo.Notes); the slug only picks the MAC views and the audit form name.
 */
export function suboutDocsOwner(form: 'entry' | 'test-order'): DocsOwner {
  return {
    apiBase: `/api/v1/subout-orders/${form}`,
    formName: form === 'entry' ? 'Subout Sample Result Entry' : 'Subout Test Order',
    businessObject: 'Subout',
    exportPrefix: 'Subcontract',
    noteTabLabel: 'Notes',
    countFromRows: true,
    legacyListBar: true,
  };
}
